/** Writing direction for a locale; Hebrew is the only right-to-left locale we serve. */
export function textDirection(locale: string): 'rtl' | 'ltr' {
	return locale === 'he' ? 'rtl' : 'ltr';
}
